import React from 'react';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem } from 'reactstrap';

import logo from '../img/logo-black-40h.png'

export default class Example extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <div style={{ background:'white', maxWidth: 1200, margin: 'auto', padding: '0px' }}>
        <Navbar color="white" light expand="md">
          <NavbarBrand href="/"><img  src={logo} width=""/>
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
            <NavItem>
                <NavLink href="/" style={{color:'black', fontSize:'14px'}} >HOME</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/livestream/" style={{color:'black', fontSize:'14px'}}  >LIVESTREAM</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/events/" style={{color:'black', fontSize:'14px'}}  >EVENTS</NavLink>
              </NavItem>
              {/* 
              <NavItem>
                <NavLink href="/sermons/">Sermons</NavLink>
              </NavItem>
                */}
              <NavItem>
                <NavLink href="https://www.youtube.com/playlist?list=PLwDTrw4NYg8OYF4kaA0SbhzbprwE9QNM0" target="_new" style={{color:'black', fontSize:'14px'}}  >SERMONS</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/resources/" style={{color:'black', fontSize:'14px'}} >RESOURCES</NavLink>
              </NavItem>
              {/*
              <NavItem>
                <NavLink href="/volunteers/" style={{color:'black', fontSize:'14px'}} >VOLUNTEERS</NavLink>
              </NavItem>
              */}
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret style={{color:'black', fontSize:'14px'}} >
                  ABOUT US
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem>
                    <a href="/about-ifgf/"  style={{color:'navy', fontSize:'12px'}}   >ABOUT IFGF</a>
                  </DropdownItem>
                  <DropdownItem>
                    <a href="/about-mission-and-vision/"  style={{color:'navy', fontSize:'12px'}}  >MISSION AND VISION</a>
                  </DropdownItem>
                  <DropdownItem>
                    <a href="/about-our-team/"  style={{color:'navy', fontSize:'12px'}}  >OUR TEAM</a>
                  </DropdownItem>
                  <DropdownItem>
                    <a href="/about-statement-of-faith/"  style={{color:'navy', fontSize:'12px'}}  >STATEMENT OF FAITH</a>
                  </DropdownItem>
                  <DropdownItem>
                    <a href="/about-dna-and-values/"  style={{color:'navy', fontSize:'12px'}}  >DNA AND VALUES</a>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret style={{color:'black', fontSize:'14px'}} > 
                  CONNECT
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem>
                    <a href="/connect-small-group/" style={{color:'navy', fontSize:'12px'}}  >SMALL GROUPS</a>
                  </DropdownItem>
                  <DropdownItem>
                    <a href="/connect-prayer-group/" style={{color:'navy', fontSize:'12px'}}   >TUESDAY NIGHT PRAYER</a>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown> 
              
              <NavItem>
                <NavLink href="https://ifgfaustin.churchcenter.com/giving/to/tithe" target="_new" style={{color:'white', backgroundColor:'orange'}}>Online Giving</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/navigation.js